import toggleUndoDarkMode from 'owa-mail-reading-pane-store/lib/actions/toggleUndoDarkMode';
import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import * as React from 'react';

export default function onToggleUndoDarkMode(viewState: ItemViewState) {
    return (event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        toggleUndoDarkMode(viewState);
    };
}
